export class DefaultWrittenSettings {
  constructor() {
    this.enable_annonymous = true;
    this.enable_grading =	true;
    this.end_date = new Date();
    this.hard_close = false;
    this.is_email_notifications = false;
    this.is_genie_feedback_enable = true;
    this.original_timezone_end_date = null;
    this.peer_assessment_questions = [];
    this.point_cap = null;
    this.require_submission = true;
    this.is_ended = null;
    this.points_settings = [];
    this.max_score = null;
    /* ------------------------------------------ */
    this.close_date_enable = false;
    this.selected_criteria_tags = [];
  }
}
export class Question {
  constructor (name, is_active, is_custom) {
    this.question = name;
    this.is_active = is_active;
    this.is_custom = is_custom;
  }
}

export class Questions {
  constructor() {
    this.questions = [];
  }
  newQuestion(name, is_active, is_custom) {
    const question = new Question(name, is_active, is_custom);
    this.questions.push(question);
    return question;
  }
  get allQuestions() {
    return this.questions;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/New_RoundTable/Utils/Objects/DefaultWrittenSettings.js